import type { CollectionSlug, CollectionUUID } from '@library/menu-service'

import type { MenuCollectionsState } from 'reducers/menu-collections/menuCollections'
import { CollectionId, CollectionSlug as MenuCollectionSlug } from 'routes/Menu/domains/collections'

import { getCollection } from './getCollection'

const getCollectionSlugFromQuery = (state: MenuCollectionsState): CollectionSlug | null => {
  if (
    !state.routing ||
    !state.routing.locationBeforeTransitions ||
    !state.routing.locationBeforeTransitions.query ||
    !state.routing.locationBeforeTransitions.query.collection
  ) {
    return null
  }

  const collection = state.routing.locationBeforeTransitions.query.collection as
    | CollectionSlug
    | CollectionSlug[]
    | undefined

  // unlikely case that collectionSlug will be an array
  if (Array.isArray(collection)) {
    return collection[0] || null
  }

  return collection || null
}

export const getCollectionIdBySlug =
  (slug: CollectionSlug | null) =>
  (state: MenuCollectionsState): CollectionUUID | null => {
    if (!slug || !state.menuV3Collections) {
      return null
    }

    if (slug === MenuCollectionSlug.Browse) {
      return CollectionId.Browse
    }

    return state.menuV3Collections.slugToId[slug] || null
  }

export const getCurrentCollectionId = (state: MenuCollectionsState): CollectionUUID => {
  const selectedCollectionSlug = getCollectionSlugFromQuery(state)
  const selectedCollectionId = getCollectionIdBySlug(selectedCollectionSlug)(state)

  if (selectedCollectionId === CollectionId.Browse) {
    return CollectionId.Browse
  }

  const selectedCollection = getCollection(selectedCollectionId)(state)
  if (selectedCollection && selectedCollection.recipes.length > 0) {
    return selectedCollection.id
  }

  return state.menuV3Collections?.firstCollectionId || CollectionId.AllRecipes
}
